// 获取环境变量
export const getEnv = () => process.env.ENV || 'prod';

// 是否为生产环境
export const isProdEnv: boolean = getEnv() === 'prod';

// 是否为测试环境
export const isTestEnv: boolean = getEnv() === 'test';

// 是否为开发环境
export const isDevEnv: boolean = getEnv() === 'dev';

// 是否是本地环境
export const isLocalEnv: boolean = process.env.IS_LOCAL === 'true';

/**
 * 判断是否在服务端运行 (Next.js 常用)
 */
export const isServer = typeof window === 'undefined';
